'use client';
import ErrorLayout, { ErrorType } from '@/components/common/ErrorLayout';
import UpdateRequiredLayout from '@/components/common/UpdateRequiredLayout';
import { useChunkErrorVersionCheck } from '@/helper/useChunkErrorVersionCheck';
import React from 'react';

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}): React.JSX.Element | null {
  // A chunk-load failure caused by a fresh deploy needs a hard
  // reload, not the usual countdown-to-home flow. Probe first; while
  // probing, render nothing to avoid flashing the ErrorLayout and
  // then snapping to a different screen once the probe confirms.
  const probe = useChunkErrorVersionCheck(error);
  if (probe === 'probing') {
    return null;
  }
  if (probe === 'version-changed') {
    return <UpdateRequiredLayout />;
  }
  console.error(error);
  return <ErrorLayout type={ErrorType.COMMON} countdown={120} error={error} reset={reset} />;
}
